import withStyles from "@material-ui/core/styles/withStyles";
import theme from "styles/theme";
import Button from "@material-ui/core/Button";

export const styles = {
    boxStyle: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "25%",
        height: "25%",
        minHeight: "35vh",
        bgcolor: "background.paper",
        borderRadius: "20px",
        boxShadow: 24,
        overflow: "auto",
        "& .MuiButton-root": {
            fontFamily: "Lato, sans-serif !important",
        },
        "& .subtitle": {
            fontSize: "12px !important",
            fontStyle: "normal !important",
            fontWeight: "400 !important",
            lineHeight: "20px !important",
            paddingTop: "5px !important",
            color: `${theme.palette.darkerGrey} !important`,
        },
    },
    typeStyle: {
        padding: "16px 16px",
        display: "flex",
        flexDirection: "row" as "row",
        justifyContent: "space-between",
        alignItems: "center",
    },
    cancelWrapperStyle: {
        padding: "20px 24px",
        display: "flex",
        flexDirection: "row" as "row",
        justifyContent: "flex-end",
    },
    cancelButtonStyle: {
        textTransform: "none" as "none",
        fontWeight: "bold" as "bold",
        fontSize: "1.3rem",
    },
    contentStyle: {
        height: "100%",
        display: "flex",
        flexDirection: "column" as "column",
        justifyContent: "space-between",
        fontFamily: "Lato, sans-serif !important",
    },
};

export const typeStyle = (index: number) => {
    const { borderColor } = theme.palette;

    if (index === 0) {
        return { border: `1px ${borderColor}`, borderStyle: "solid none" };
    }

    return { borderBottom: `1px solid ${borderColor}` };
};

export const TypeButton = withStyles({
    root: {
        padding: 0,
        margin: 0,
        width: "100%",
        textTransform: "none",
        display: "unset",
        textAlign: "left",
    },
})(Button);
